// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import Storage from '@/utils/storage';
import ManageInventorySubcategory from '@/components/inventory-subcategory/manage';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function EditInventorySubcategory() {
    const router = useRouter();
    const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  
    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };
  
    useEffect(() => {
        getAccessStatus();
    }, []);
    
    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    const { data: inventorySubcategory } = useQuery(
        ['inventorySubcategory', id],
        () => Fetch.get({ url: `/InventorySubcategory?id=${id}` }),
        { enabled: !!id }
    );

    if (!inventorySubcategory) return null;

    return (
        <div>
            <ManageInventorySubcategory isNew={false} manageInventorySubcategory={inventorySubcategory} accessStatus={accessStatus} />
        </div>
    );
}

export default EditInventorySubcategory;

export const Route = createFileRoute('/_authenticated/inventory-subcategory/$id')({ component: EditInventorySubcategory })
